"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsubscribeNotificationApiCall = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const unsubscribeNotificationApiCall = (url, event) => (0, abortable_fetch_1.abortableFetch)(`${url}/preferences/unsubscribe/${event}`, {
    method: 'PUT',
});
exports.unsubscribeNotificationApiCall = unsubscribeNotificationApiCall;
//# sourceMappingURL=unsubscribe-hook.js.map